import "./css/facility.css";

const Facility = ({ name, icon_url }) => {
  return (
    <div className="facility">
      <div className="icon_container_outer">
        <div className="icon_container_inner">
          <img src={icon_url} alt={name} />
        </div>
      </div>
      <p>{name}</p>
    </div>
  );
};

export default Facility;
